(function ($) {
	'use strict';
	//console.log('Child theme loaded');

	if (typeof $.fn.slick !== 'undefined') {
		// console.log('Slick carousel is loaded');

		let categories = [];
		let aGroup = [];
		let bGroup = [];
		let cGroup = [];

		let dotsDiameter = $('.slick-dots').height();
		let radius = dotsDiameter / 2;

		const hideActive = () => {
			$('.slick-dots li.slick-active').removeClass('slick-active');
		};

		const toggleInactivity = (group, value) => {
			hideActive();
			$(`.slick-dots li[role="presentation"]:not([data-group-${group}])`).attr(
				'data-inactive',
				value
			);
		};

		const handleGroups = () => {
			$('.group-a-toggle')
				.on('mouseenter', () => {
					//console.log('group-a-toggle');

					$('[data-group-a]').attr('data-hover', true);
					toggleInactivity('a', true);
				})
				.on('mouseleave', () => {
					//console.log('group-a-mouseleave');
					$('[data-group-a]').attr('data-hover', false);
					toggleInactivity('a', false);
				});
			$('.group-b-toggle')
				.on('mouseenter', () => {
					//console.log('group-b-toggle');
					$('[data-group-b]').attr('data-hover', true);
					toggleInactivity('b', true);
				})
				.on('mouseleave', () => {
					//console.log('group-b-mouseleave');
					$('[data-group-b]').attr('data-hover', false);
					toggleInactivity('b', false);
				});
			$('.group-c-toggle')
				.on('mouseenter', () => {
					//console.log('group-c-toggle');
					$('[data-group-c]').attr('data-hover', true);
					toggleInactivity('c', true);
				})
				.on('mouseleave', () => {
					//console.log('group-c-mouseleave');
					$('[data-group-c]').attr('data-hover', false);
					toggleInactivity('c', false);
				});
		};
		handleGroups();

		const handleButtons = () => {
			/** Take the slick active away so no category is selected on startup */
			categories = [];
			// const circleDiameterXs = 260; // Set in the CSS
			// const circleDiameterSm = 324;
			// const circleDiameterLg = 594;

			// // Space between the inner container and the dots circle
			// const dotsOffsetXs = 16; // 1rem in pixels
			// const dotsOffsetSm = 16; // 1rem in pixels
			// const dotsOffsetLg = 16; // 1rem in pixels

			// // Dots circle diameter
			// const dotsDiameterXs = circleDiameterXs + 2 * dotsOffsetXs;
			// const dotsDiameterSm = circleDiameterSm + 2 * dotsOffsetSm;
			// const dotsDiameterLg = circleDiameterLg + 2 * dotsOffsetLg;

			dotsDiameter = $('.slick-dots').height();
			radius = dotsDiameter / 2;
			//console.log('dotsDiameter, radius, center', dotsDiameter, radius);
			const slickClasses = [
				'slick-slide',
				'slick-active',
				'slick-cloned',
				'slick-current',
			];

			const setGroups = (group, index) => {
				group = group.split('-')[1];
				if (group === 'a') {
					aGroup = [...aGroup, index];
				}
				if (group === 'b') {
					bGroup = [...bGroup, index];
				}
				if (group === 'c') {
					cGroup = [...cGroup, index];
				}
			};
			$('.USP-slider-carousel')
				.find('.slick-track')
				.children()
				.not('.slick-cloned')
				.each(function (index) {
					const classes = $(this).attr('class').split(' ');
					const secondClass = classes[1];
					const thirdClass = classes[2];
					const fourthClass = classes[3];
					const fifthClass = classes[4];

					if (thirdClass && !slickClasses.includes(thirdClass)) {
						//console.log(thirdClass, 'thirdClass');
						setGroups(thirdClass, index);
					}
					if (fourthClass && !slickClasses.includes(fourthClass)) {
						//console.log(fourthClass, 'fourthClass');
						setGroups(fourthClass, index);
					}
					if (fifthClass && !slickClasses.includes(fifthClass)) {
						//console.log(fifthClass, 'fifthClass');
						setGroups(fifthClass, index);
					}

					if (secondClass && secondClass !== 'slick-slide') {
						let secondClassStyled = secondClass
							.replace(/-/g, ' ')
							.toUpperCase(); // Capitalize the category name
						categories = [...categories, secondClassStyled];
					}
				});
			//console.log('Categories:', categories);
			let listItemButtons = $('.slick-dots li');
			if (listItemButtons.length === categories.length) {
				let angle = -(2 * Math.PI) / categories.length; // Minus sign for flippig coordinates
				//console.log('angle', angle);
				listItemButtons.each(function (index) {
					// console.log('this.style.top', this.style.top);
					$(this).attr('data-categoryname', categories[index]);

					this.style.transfromOrigin = `center center`;

					this.style.top = radius;
					this.style.left = radius;
					const x = Math.cos(index * angle) * radius;
					const y = Math.sin(index * angle) * radius;
					this.style.transform = `translate(calc(${radius}px + ${x}px), ${y}px)`;
					$(this).attr(
						'data-render-text',
						x.toPrecision(2) < 0 ? 'left' : 'right'
					);
					aGroup.includes(index) ? $(this).attr('data-group-a', true) : null;
					bGroup.includes(index) ? $(this).attr('data-group-b', true) : null;
					cGroup.includes(index) ? $(this).attr('data-group-c', true) : null;
				});
			} else {
				// console.log(
				// 	'The number of categories and the number of dot buttons do not match. Check, whether you have added a class to the slide with the category name, whether you have enabled dots in the carousel settings'
				// );
			}
			//console.log('USP slider ready');
		};

		$('.USP-slider-carousel').on('init breakpoint setPosition', () => {
			$('.USP-slider-carousel').slick('slickSetOption', 'fade', true, false);
			$('.USP-slider-carousel').slick('slickSetOption', 'swipe', false, false);
			$('.USP-slider-carousel').slick(
				'slickSetOption',
				'cssEase',
				'ease',
				false
			);

			handleButtons();
		});

		screen.orientation.addEventListener('change', (event) => {
			const type = event.target.type;
			const angle = event.target.angle;
		});

		// $('.USP-slider-carousel').on('breakpoint', () => {
		// 	$(this).slick('setPosition');
		// 	handleButtons();
		// 	true, true;
		// });

		// $('.USP-slider-carousel').on('breakpoint', handleButtons, true);

		$('.USP-slider-carousel').slick('slickSetOption', 'fade', true, false);
		$('.USP-slider-carousel').slick('slickSetOption', 'swipe', false, false);
		// $('.USP-slider-carousel').slick(
		// 	'slickSetOption',
		// 	'appendDots',
		// 	'.slick-track',
		// 	false
		// );

		const addCategoryEventListeners = () => {
			categories.forEach((category, index) => {
				$(`.${category.toLowerCase().replace(/ /g, '-')}-toggle`).on(
					'click',
					() => {
						$('.USP-slider-carousel').slick('slickGoTo', index);
					}
				);
			});
		};
		hideActive();
		handleButtons();
		addCategoryEventListeners();

		$('.wp-block-cover').on('click', function (e) {
			if (
				!$(e.target).closest('.slick-dots li').length &&
				!$(e.target).closest('.slick-track').length
			) {
				//console.log('Clicked outside of dot button');
				// if ($('.USP-slider-carousel').hasClass('visible')) {
				// 	$('.USP-slider-carousel').toggleClass('visible hidden');
				// 	$('.USP-slider-carousel').slick('refresh', true);
				// }
			} else {
				if ($('.USP-slider-carousel').hasClass('hidden')) {
					$('.USP-slider-carousel').toggleClass('visible hidden');
					//$('.USP-slider-carousel').slick('refresh', true);
					//setTimeout(() => handleButtons(), 1000);
				}
			}
		});
	}
})(jQuery);
